import React from 'react';
import styles from './CardActionButton.module.scss';

/**
 * Reusable icon+label action button for the JuryProjectCard action bar.
 * Supports a 'default' (gray→primary) and 'danger' (gray→dark) hover variant.
 */
function CardActionButton({ icon, label, onClick, ariaLabel, variant = 'default', disabled = false }) {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!disabled) onClick();
    };

    return (
        <button
            className={`${styles.ActionButton} ${variant === 'danger' ? styles.ActionButtonDanger : ''}`}
            onClick={handleClick}
            aria-label={ariaLabel}
            disabled={disabled}
        >
            {icon}
            <span className={styles.ActionLabel}>{label}</span>
        </button>
    );
}

export default CardActionButton;
